import cookies from 'utility/cookies'

type OrderDetailType = {
  bookingNo: string
  bookingCode: string
  expiry: string
}

const local_storage = {
  el: {
    cartNumber: null as HTMLSpanElement | null,
  },
  init() {
    this.el.cartNumber = document.querySelector('.cart-button__counter__text')

    this.firstLoad()
  },
  firstLoad() {
    const orderDetails = JSON.parse(localStorage.getItem('tr_orderDetails') as string) as OrderDetailType

    if (orderDetails) {
      const expiryDate = new Date(orderDetails.expiry)

      if (new Date() > expiryDate) {
        this.removeOrderDetails(orderDetails)
      }
    }

    if (this.el.cartNumber) {
      const cartTotal = Number.parseInt(this.el.cartNumber.textContent as string)

      if (cartTotal === 0) {
        this.removeOrderDetails(orderDetails)
      }
    }
  },
  removeOrderDetails(orderDetails: OrderDetailType) {
    if (orderDetails) {
      localStorage.removeItem('tr_orderDetails')
    }

    const cookie = cookies.read('TRCart')

    if (cookie) {
      cookies.delete('TRCart')
    }
  },
}

export default local_storage
